import api from './client';

export const userAPI = {
  getAllUsers: async (page = 1, limit = 10) => {
    const response = await api.get(`/users?page=${page}&limit=${limit}`);
    return response.data;
  },

  getUserById: async (id) => {
    const response = await api.get(`/users/${id}`);
    return response.data;
  },

  createUser: async (userData) => {
    const response = await api.post("/users", userData);
    return response.data;
  },

  updateUser: async (id, userData) => {
    const response = await api.put(`/users/${id}`, userData);
    return response.data;
  },

  deleteUser: async (id) => {
    const response = await api.delete(`/users/${id}`);
    return response.data;
  },

  getUsersByRecruiter: async (recruiterId) => {
    const response = await api.get(`/users/recruiter/${recruiterId}`);
    return response.data;
  },

  updateUserStatus: async (id, statusData) => {
    const response = await api.patch(`/users/${id}/status`, statusData);
    return response.data;
  },
};

// Recruiter Management API
